'use strict';

const wishlist = require('wishlist/product/wishlist');
const {getCsrfObject} = require('app_common/components/security');

/**
 * お気に入り登録時のAJAX通信の結果区分
 *
 * @protected
 * @constant {string}
 * @author SCSK 中村勝紀
 */
const AJAX_RESPONSE_ERR_EXIST = 'errExist';
const AJAX_RESPONSE_ERR_AT_MAX = 'errAtMax';
const AJAX_RESPONSE_ERR_OTHER = 'errOther';

/**
 * お気に入り登録時のメッセージ表示コントロール
 *
 * @param {object} data お気に入り登録Ajaxサービスを呼び出した結果
 * (登録成功時)
 * ```js
 * {
 *    success: true,
 *    pid: '<商品ID>',
 *    msg: '<メッセージID'>
 * }
 * ```
 * (登録失敗時)
 * ```js
 * {
 *    error: true,
 *    pid: '<商品ID>',
 *    msg: '<メッセージID>'
 * }
 * ```
 * - 「商品ID」は、お気に入り登録時に送信した商品IDに該当する。
 * -「メッセージID」は以下で定義するいずれかに該当する。
 *     - AJAX_RESPONSE_ERR_EXIST
 *     - AJAX_RESPONSE_ERR_AT_MAX
 *     - AJAX_RESPONSE_ERR_OTHER
 * @param {jQuery<Element>} $button - 「お気に入りに追加」ボタンを表すjQueryオブジェクト
 * @returns {void}
 * @author SCSK 中村勝紀
 */
function displayMessage(data, $button) {
    // スピナー画面停止
    $.spinner().stop();

    let message = '';
    let status = 'alert-success';

    // AJAXの結果で表示するメッセージを調整
    if (data.success) {
        // お気に入りに追加できた場合
        message = $('.add-to-wishlist-popup .add-to-wishlist-first').html();
    } else if (data.msg === AJAX_RESPONSE_ERR_EXIST) {
        // すでに登録されていた場合
        message = $('.add-to-wishlist-popup .add-to-wishlist-error-exist').html();
    } else if (data.msg === AJAX_RESPONSE_ERR_AT_MAX) {
        // 上限に達している場合
        message = $('.add-to-wishlist-popup .add-to-wishlist-error-atmax').html();
    } else if (data.msg === AJAX_RESPONSE_ERR_OTHER) {
        // 他のエラーが発生した場合
        message = $('.add-to-wishlist-popup .add-to-wishlist-error-other').html();
    } else if (data.csrfError) {
        // CSRFトークンエラーの場合
        message = $('.add-to-wishlist-popup .add-to-wishlist-error-csrf').html();
    } else {
        // 予期せぬエラーの場合
        message = $('.add-to-wishlist-popup .add-to-wishlist-error-system').html();
    }

    let $messages = $('.add-to-cart-messages');
    if ($messages.length === 0) {
        $messages = $('<div class="add-to-cart-messages"></div>');
        $('body').append($messages);
    }

    // クラス追加
    const $alert = $(
        `<div class="alert ${status} add-to-basket-alert text-center" role="alert">${message}</div>`
    );
    $messages.append($alert);

    // アイコンCSS
    if (data.success) {
        if (!$button.hasClass('tny-heart-on')) {
            $button.addClass('tny-heart-on');
        }
    }
    // タイムアウトセット（5秒）
    setTimeout(function () {
        $alert.remove();
        $messages.remove();
        $button.removeAttr('disabled');
    }, 5000);
}

/**
 * お気に入りに追加
 * plugin_wishlistから移植
 * AJAX通信後の処理のみ改修
 *
 * @returns {void}
 * @author 中村勝紀
 */
function addToWishlist() {
    $(document).on('click', '.add-to-wish-list', async function (e) {
        e.preventDefault();

        // htmlから情報取得
        let url = $(this).data('href');
        let $button = $(this);
        // TODO：pidの取り方についてtaneya-store（商品系機能）と調整が必要
        let pid =
            $(this).closest('.product-detail').find('.product-id').html() ||
            $(this).data('product-id');
        let optionId = $(this)
            .closest('.product-detail')
            .find('.product-option')
            .attr('data-option-id');
        let optionVal = $(this)
            .closest('.product-detail')
            .find('.options-select option:selected')
            .attr('data-value-id');

        optionId = optionId || null;
        optionVal = optionVal || null;
        if (!url || !pid) {
            return;
        }

        // スピナー画面のスタート
        $.spinner().start();

        $(this).attr('disabled', true);

        const csrfObject = getCsrfObject();
        const csrfTokenName = csrfObject.tokenName;
        const csrfTokenValue = csrfObject.token;
        const postdata = {
            pid,
            optionId,
            optionVal,
        };
        postdata[csrfTokenName] = csrfTokenValue;

        // AJAX通信
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: postdata,
            success: function (data) {
                displayMessage(data, $button);
            },
            error: function (err) {
                displayMessage(err.responseJSON || {}, $button);
            },
        });
    });
}

const exportWishlist = $.extend({}, wishlist, {
    addToWishlist,
});

module.exports = exportWishlist;
